import { Controller } from "@hotwired/stimulus"

// Rewrites its element's text to a timestamp formatted in the browser's local
// timezone. Give it data-local-time-iso-value="<ISO-8601 UTC>"; the element's
// server-rendered text stays as the no-JS fallback until connect() runs.
export default class extends Controller {
  static values = { iso: String }

  connect() {
    const date = new Date(this.isoValue)
    if (isNaN(date)) return // leave server fallback text in place
    this.element.textContent = date.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
    })
  }
}
